// extracted by mini-css-extract-plugin
export default {"backButton":"BackButton_backButton__SI3qJ","icon":"BackButton_icon__w-sxb"};